import React from 'react';
import { Tab as MuiTab } from '@mui/material';

import type { TabProps } from './types';

export default function Tab({ ...props }: TabProps) {
  return <MuiTab {...props} />;
}
